import { useQuery } from '@tanstack/react-query'
import { ShopItemsService } from '@/modules/shop/api/services/ShopItemsService'
import type { paths } from '@/schema'

type GetShopItemPresetsResponse =
	paths['/api/admin/shop/items/presets']['get']['responses']['200']['content']['application/json']

export default function useQueryGetShopItemPresets() {
	return useQuery<GetShopItemPresetsResponse>({
		queryKey: ['shop-item-presets'],
		queryFn: () => ShopItemsService.getShopItemPresets(),
	})
}
